import React, { useState } from "react";

import {
    ServerCmsModelsPagesArticleArticleSnippet,
    ArticlesGridBlock as Value,
} from "@reactivated";

import { ArticleCard } from "../ArticleCardsBlock/ArticleCard";
import { ButtonPrimary } from "../Clickables";
import { SectionHeaderBlock } from "../SectionHeaderBlock";

import styles from "./index.module.scss";

interface Props {
    value: Value;
    articles: ServerCmsModelsPagesArticleArticleSnippet[];
    id?: string;
}

const INITIAL_VISIBLE_ARTICLES = 12;

export const ArticlesGridBlock = ({ value, articles, id }: Props) => {
    const [visibleCount, setVisibleCount] = useState(INITIAL_VISIBLE_ARTICLES);

    const visibleArticles = articles.slice(0, visibleCount);
    const hasMore = visibleCount < articles.length;

    const handleLoadMore = () => {
        setVisibleCount((prev) =>
            Math.min(prev + INITIAL_VISIBLE_ARTICLES, articles.length),
        );
    };

    return (
        <div className={styles.root}>
            {value.title && (
                <SectionHeaderBlock value={{ text: value.title }} />
            )}
            <ul className={styles.grid}>
                {visibleArticles.map((article) => (
                    <li key={`${id}-${article.id}`} className={styles.gridItem}>
                        <ArticleCard article={article} />
                    </li>
                ))}
            </ul>
            {hasMore && (
                <div className={styles.loadMoreContainer}>
                    <ButtonPrimary type="button" onClick={handleLoadMore}>
                        Load More
                    </ButtonPrimary>
                </div>
            )}
        </div>
    );
};
